import EventEmitter from 'eventemitter3'

export class System extends EventEmitter {
  constructor(client) {
    super()
    this.client = client
  }

  async init() {
    // runs once when world is initialized, used to asynchronously allow systems to set themselves up
  }

  start() {
    // runs once after all systems are initialized, and before the world begins simulating
  }

  preTick() {
    // ...
  }

  preFixedUpdate(willFixedStep) {
    // ...
  }

  fixedUpdate(delta) {
    // ...
  }

  postFixedUpdate(delta) {
    // ...
  }

  preUpdate() {
    // ...
  }

  update(delta) {
    // ...
  }

  postUpdate(delta) {
    // ...
  }

  lateUpdate(delta) {
    // ...
  }

  postLateUpdate(delta) {
    // ...
  }

  commit() {
    // ...
  }

  postTick() {
    // ...
  }
}
